export const ROUTE_CONST = {
  AGENTS: "/agents",
  ASSISTANTS: "/assistants",
  DIGITAL_EMPLOYEE: "/digitalemployee",
  DISCOVER: "/discover",
  MYTEAM: "/myteam",
  RAGS: "/rags",
  PROCESSES: "/processes",
  LOGIN: "/login",
  HOME: "/home",
};

export const VOICE_ROUTES = {
  VOICE_REALTIME_OS: "/ltimmultiplex",
  VOICE_REALTIME_AZURE: "/saasltimmultiplex",
  VOICE_STANDARD_OS: "/ltimsonus",
  VOICE_STANDARD_AWS: "/saasvoicekit/awsvoicekit",
  VOICE_STANDARD_AZURE: "/saasvoicekit/azurevoicekit",
};
